export default __webpack_public_path__ + "static/33F324_A_0-46b024222fef2bfaaf2a5ce229a6828d.woff";